import { render, staticRenderFns } from "./UsersPointUpdate.vue?vue&type=template&id=18db640c&scoped=true&"
import script from "./UsersPointUpdate.vue?vue&type=script&lang=js&"
export * from "./UsersPointUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UsersPointUpdate.vue?vue&type=style&index=0&id=18db640c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db640c",
  null
  
)

export default component.exports